import React from 'react';
import { Icon } from '@iconify-icon/react';
import { cn } from '#lib/helpers/class.js';

export function RowDiff(props) {
    const { el, elIsPresent, elToAdd, onUpdateElement, onRestoreElement } = props;

    return (
        <div
            className={cn(
                'flex items-center w-[500px] xl:w-[480px] border border-neutral-200 rounded-md bg-neutral-50',
                elToAdd && 'opacity-70'
            )}
        >
            <p className="flex-grow text-sm text-center no-whitespace text-ellipsis overflow-hidden col-span-5 max-h-32 p-2">
                {el?.name || 'Untitled'}
            </p>
            {!elToAdd && (
                <>
                    {elIsPresent ? (
                        <Icon
                            icon="fa6-solid:xmark"
                            width="1.2rem"
                            height="1.2rem"
                            className="px-2 cursor-pointer text-red-500 hover:text-red-600"
                            onClick={onRestoreElement}
                        />
                    ) : (
                        <Icon
                            icon="el:ok"
                            width="1.2rem"
                            height="1.2rem"
                            className="px-2 cursor-pointer text-primary-500 hover:text-primary-600"
                            onClick={onUpdateElement}
                        />
                    )}
                </>
            )}
        </div>
    );
}
